import axios from 'axios';
import { DossierId } from '@/dossier/models/AbstractDossier';
import { formatJobPartsData, parseJobItems } from '../converters/jobItemConverters';
import { JobId } from '../models/AbstractJob';
import JobItem, { JobItemId, JobPartsData } from '../models/JobItem';

class JobItemClient {
  async loadAll(dossierId: DossierId): Promise<Array<JobItem>> {
    const response = await axios.get(`/api/mobopro/v1/dossiers/${dossierId}/invoiceitems`, {
      params: {
        includedeleted: true,
      },
    });
    return parseJobItems(response.data);
  }

  async link(itemId: JobItemId, jobId: JobId | null, dossierId: DossierId): Promise<void> {
    await axios.patch(`/api/mobopro/v1/dossiers/${dossierId}/invoiceitems/${itemId}`, { jobId });
  }

  async linkAllFromJob(sourceId: JobId, targetId: JobId | null, keepSource: boolean, dossierId: DossierId): Promise<void> {
    await axios.put(`/api/mobopro/v1/dossiers/${dossierId}/invoiceitems`, {
      jobIdSource: sourceId,
      jobIdTarget: targetId,
      keepSource,
    });
  }

  async updateStatus(data: JobPartsData, dossierId: DossierId): Promise<void> {
    await axios.put(`/api/mobopro/v1/dossiers/${dossierId}/invoiceitems/warehousing`, formatJobPartsData(data));
  }
}

export default new JobItemClient();
